import React, { Component } from 'react';
//import EventImg from '../../assets/images/yoga.png';
import Carousel from "react-multi-carousel";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1200 },
    items: 3,
    slidesToSlide: 3, // optional, default to 1.
  },
  laptop: {
    breakpoint: { max: 1200, min: 992 },
    items: 3,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 992, min: 768 },
    items: 3,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 3,
    slidesToSlide: 1, // optional, default to 1.
  },
};


const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/events/';


export default class UpcomingEventsPage extends Component {
    constructor(props) {
        super(props)

        this.day_arr = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
        this.callender = [];
    }

    HandleDate = (startDate) =>{
          startDate.replace(/  /g, 'T');
        var monthArr = [ "January", "February", "March", "April", "May",
        "June", "July", "August", "September", "October",
        "November", "December"];

        var dayArr = ["Sunday" , "Monday" , "Tuesday" , "Wednesday" , "Thursday" , "Friday" , "Saturday"];

        var date = new Date(startDate).getDate()
        var month = new Date(startDate).getMonth()
        var day = new Date(startDate).getDay()

        let finalDate = ''

        if(date <10){
            date = '0'+date;
        }


        finalDate = monthArr[month]+' ' + date +',' + ' ' + dayArr[day];

        return finalDate;
      //  alert(date)

    }

    HandleTime = (startTime) => {
        startTime = startTime.replace(/  /g, 'T')
        var hr = new Date(startTime).getHours();
        var min = new Date(startTime).getMinutes();
        let final;

        if (hr > 12) {
            hr = hr - 12
            if (min < 10) {
                min = '0' + min;
            }
            final = hr + ':' + min + ' ' + 'PM';
        }
        else if (hr == 12) {
            if (min < 10) {
                min = '0' + min;
            }
            final = hr + ':' + min + ' ' + 'PM';
        }
        else {
            if (min < 10) {
                min = '0' + min;
            }
            final = hr + ':' + min + ' ' + 'AM';
        }

        return final;
    }

    GetSliderData = (day, date, sessionDate) => {
       // alert(sessionDate);
      //   alert(date + "----" + date + "---" + day);
        // alert('DIV ID ====' + 'div' + month + "" + date);
    
        var elems = document.querySelectorAll(".filter-date-div");
        [].forEach.call(elems, function (el) {
          if (el.classList.contains("active")) {
            // alert(el.classList.contains("active"));
            el.classList.remove("active");
          }
        });
        var element = document.getElementById('div' + day + "" + date);
        element.classList.add("active");
    
       this.props.FilterData(sessionDate);
    
      }
    componentDidMount = ()=>{

        let curr_date = new Date();
        for (var i = 0; i < 15; i++) {
          //  let sessionDate = curr_date.toDateString();
            //sessionDate.toDateString()
            if (i !== 0) {
              curr_date.setDate(curr_date.getDate() + 1)
            }
            let sessionDate = '';
            let yyyy = curr_date.getFullYear();
            let mm = curr_date.getMonth() +1;
            let dd = curr_date.getDate();

            if(mm<10){
                mm = '0'+mm
            }
            if(dd<10){
                dd = '0'+dd
            }
            sessionDate = yyyy+'-'+mm+'-'+dd;

            let date = curr_date.getDate();
           // let month = this.month_arr[curr_date.getMonth()]
            let day = this.day_arr[curr_date.getDay()]
            this.callender.push({
              date: date,
              day: day,
              sessionDate:sessionDate
            })
      
          //  console.log(date + '---' + month + '---' + day);
          }
      
    }

    render() {
        return (
            <div>
                <div className="upcoming-events-main">
                    <div className="container-fluid">

                        <div className="upcoming-events-head">
                        <div className='upcoming-head'>
                            <div className='row'>
                                <div className='col-12 col-md-6 col-lg-6'>
                                    <div><h3>Upcoming Sessions</h3></div>
                                </div>
                                {
                                    this.callender.length>0 ?
                                
                                <div className='col-12 col-md-6 col-lg-6'>
                                <div className='card filter-main-div'>

                                
                                <Carousel
                                swipeable={true}
                                draggable={true}
                                responsive={responsive}
                                infinite={true}
                                // autoPlay={true}
                                autoPlaySpeed={2000}
                                keyBoardControl={true}
                                customTransition="all .5"
                                transitionDuration={500}
                                containerclassName="carousel-container"
                                onClick={this.handleCarouselData}
                                id="ausaf-tour"
                                className="">
                                {
                                  this.callender.map((item) => {
                                    return (
                                       
                                        <div className='filter-date-div' id={'div' + item.day + "" + item.date}
                                        onClick={() => this.GetSliderData(item.day, item.date, item.sessionDate)}
                                        >
                                        <p>{item.date} {item.day}</p>
                                        </div>
                                       
                                    )
                                  })
                                }
                              </Carousel>
                               
                               
                                </div>
                                </div>
                            :''}
                               {/* <div className='col-5 col-md-4 col-lg-4'>
                                    <div className='filter-btn'>
                                        <button type='button' className='btn'
                                      //   data-toggle="collapse" data-target="#collapseExample" 
                                       //  aria-expanded="false" aria-controls="collapseExample"
                                       onClick={this.props.OpenFilter}
                                         >Add Filters
                                             <i  id = "arrow" class='fa fa-angle-down'></i>
                                         </button>
                                    </div>
        </div> */  }
                           {/*     <div class="collapse col-md-12 col-lg-12" id="collapseExample">
                                    <div class="card card-body filter-div">
                                        <div className='filter-form'>
                                            <form>
                                                <div className='row'>
                                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                                        <div class="form-group">

                                                            <input type="text" class="form-control form2-control-ausi"
                                                                id="txtFilterStartDate"
                                                                name="txtFilterStartDate"
                                                                placeholder="Start Date"


                                                                value={this.props.mystate.txtFilterStartDate}
                                                                onClick={this.props.HandleEventInput}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                                        <div class="form-group">

                                                            <input type="text" class="form-control form2-control-ausi"
                                                                id="txtFilterEndDate"
                                                                name="txtFilterEndDate"
                                                                placeholder="End Date"


                                                                value={this.props.mystate.txtFilterEndDate}
                                                                onClick={this.props.HandleEventInput}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                                        <div class="form-group">

                                                            <select class="custom-select mr-sm-2 form2-control-ausi"
                                                                id="ddlFilterLanguage"
                                                                name="ddlFilterLanguage"
                                                                //placeholder="Event Name"


                                                                value={this.props.mystate.ddlFilterLanguage}
                                                                onChange={this.props.HandleEventInput}
                                                            >
                                                              
                                                                <option value=''>Language</option>
                                                                <option value="English">English</option>
                                                                <option value="Hindi">Hindi</option>
                                                                <option value="Hinglish">Hinglish</option>
                                                            </select>
                                                        </div>
                                                    </div>


                                                </div>
                                                <div className='row'>
                                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                                        <div class="form-group">

                                                            <select class="custom-select mr-sm-2 form2-control-ausi"
                                                                id="ddlFilterCategory"
                                                                name="ddlFilterCategory"



                                                                value={this.props.mystate.ddlFilterCategory}
                                                                onChange={this.props.HandleEventInput}
                                                            >
                                                                <option value=''>Category</option>

                                                                {
                                                                    this.props.categorylist.length > 0 ?
                                                                        this.props.categorylist.map((item, i) => (
                                                                            item.status === 1 ?
                                                                                <option value={item.category_name}>{item.category_name}</option>
                                                                                : ''
                                                                        ))
                                                                        : ''}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                                        <div class="form-group">

                                                            <select class="custom-select mr-sm-2 form2-control-ausi"
                                                                id="ddlFilterOrganizer"
                                                                name="ddlFilterOrganizer"



                                                                value={this.props.mystate.ddlFilterOrganizer}
                                                                onChange={this.props.HandleEventInput}
                                                            >
                                                                <option value=''>Organizer</option>
                                                                {this.props.organizerlist.length > 0 ?
                                                                    this.props.organizerlist.map((item, i) => (
                                                                        item.organizer_status === 1 || item.organizer_status === '1' ?
                                                                            <option value={item._id}>{item.organizer_name}</option>
                                                                            : ''
                                                                    ))
                                                                    : ''}
                                                            </select>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div class="col-6 col-sm-6 col-md-3 col-lg-3">
                                                        <div className='filter-btn'>
                                                            <button className='btn' type='button'
                                                            onClick={this.props.ResetData} 
                                                               
                                                            >
                                                                Reset
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="col-6 col-sm-6 col-md-3 col-lg-3">
                                                  
                                                        <div className='filter-btn'>
                                                        {this.props.mystate.FilterValidation !== '' ?
                                                        <button className='btn' type='button'
                                                       
                                                       
                                                        onClick={this.props.FilterData}
                                                    >Search</button>:
                                                    <button className='btn' type='button'
                                                 //   data-toggle="collapse" data-target="#collapseExample"
                                                  //  aria-expanded="false" aria-controls="collapseExample"
                                                    onClick={this.props.FilterData}
                                                >Search</button>
                                                    }
                                                           
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                                    {this.props.mystate.FilterValidation === 'Please Choose one...' ?
                                                    <div className='ausaf-errorMessage'>
                                                    {this.props.mystate.FilterValidation}
                                                   
                                                    </div>
                                                    :''}
                                                    
                                                    </div>

                                                </div>




                                            </form>

                                        </div>

                                    </div>
                                                </div> */}
                            </div>
                            </div>

                        <div className='upcoming-list'>

                            {
                                this.props.upcomingEventsList.length > 0 ?

                                    this.props.upcomingEventsList.map((item, i) => (

                                        <div className="upcoming-events-list" key={i}>
                                            <div className="row">
                                                {
                                                    //   alert(i+1)
                                                    i > 0 ?

                                                        (new Date((this.props.upcomingEventsList[i].event_start_time).replace(/  /g, 'T')).toDateString() === new Date((this.props.upcomingEventsList[i - 1].event_start_time).replace(/  /g, 'T')).toDateString()) ?

                                                            ''
                                                            :
                                                            <div className="col-md-12 col-lg-12">

                                                                <div className="upcoming-events-date">
                                                                    <h4>{this.HandleDate(item.event_start_time)}</h4>
                                                                </div>

                                                            </div>
                                                        :

                                                        <div className="col-md-12 col-lg-12">

                                                            <div className="upcoming-events-date">
                                                                <h4>{this.HandleDate(item.event_start_time)}</h4>
                                                            </div>

                                                        </div>

                                                }
                                                {
                                                    //   alert(i+1)
                                                    i > 0 ?

                                                        (new Date((this.props.upcomingEventsList[i].event_start_time).replace(/  /g, 'T')).toDateString() === new Date((this.props.upcomingEventsList[i - 1].event_start_time).replace(/  /g, 'T')).toDateString()) ?

                                                            ''
                                                            :
                                                            <div className="col-md-12 col-lg-12">
                                                                <div className="upcoming-events-seperation-line">

                                                                </div>

                                                            </div>
                                                        :
                                                        <div className="col-md-12 col-lg-12">
                                                            <div className="upcoming-events-seperation-line">

                                                            </div>

                                                        </div>
                                                }

                                                <div className="col-md-12 col-lg-12">
                                                    <div className="upcoming-events-list-div" onClick={() => this.props.HandleRouting(item.seo_url)}>
                                                        <div className="row">
                                                            <div className="col-sm-3 col-md-3 col-lg-2">
                                                                <div className="upcoming-events-time">
                                                                    <h5>{this.HandleTime(item.event_start_time)}</h5>
                                                                    <p>{item.event_duration} mins</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-3 col-md-3 col-lg-3">
                                                                <div className="upcoming-events-img">
                                                                    <img src={img_path + item.event_image.replace(',', '')} alt="loading..." />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6 col-md-6 col-lg-7">
                                                                <div className="upcoming-events-info">
                                                                    <h6>{item.event_name + ' '}(<span>{item.event_language}</span>)</h6>
                                                                    <div className="upcoming-events-seats">
                                                                        <p>{item.event_total_seats - (item.event_filled_seats + item.event_already_filled_seats)} seats left</p>
                                                                    </div>
                                                                    <p>{item.event_desc}</p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="upcoming-events-list-div-mobile" onClick={() => this.props.HandleRouting(item.seo_url)}>
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <div className="upcoming-events-img">
                                                                    <img src={img_path + item.event_image.replace(',', '')} alt="loading..." />
                                                                </div>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="upcoming-events-time">
                                                                    <h5>{this.HandleTime(item.event_start_time)}</h5>
                                                                    <p>{item.event_duration} mins</p>
                                                                    <h6>{item.event_name + ' '}(<span>{item.event_language}</span>)</h6>
                                                                    <div className="upcoming-events-seats">
                                                                        <p>{item.event_total_seats - (item.event_filled_seats + item.event_already_filled_seats)} seats left</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="col-md-12 col-lg-12">
                                                    <div className="upcoming-events-seperation-line">

                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    ))

                                    : 
                                    
                                    <div className='booked-events-message session-list-message'>
                                    <p>No Session found as of now !!!</p>
                                    {/*<button type='button' className='btn' onClick={() => this.props.HandleRouting('upcoming-sessions')}>Go to Session List</button>*/}
                                </div>
                                }
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

